import Disciplines from '../enums/Disciplines';
import SlopeConditions from '../enums/SlopeConditions';
import SnowTypes from '../enums/SnowTypes';
import TerrainTypes from '../enums/TerrainTypes';
import CourseSetting from '../enums/CourseSetting';
import SlalomDistances from '../enums/SlalomDistances';
import i18n from 'i18next';
import {msToTime} from '../TimeStringConversion';
import {intervalStringToMilliseconds} from './IntervalTimeUtilities';

export function translateEnum(str) {
    if (Object.values(Disciplines).includes(str)) {
        return i18n.t('Disciplines.' + str);
    } else if (Object.values(SlopeConditions).includes(str)) {
        return i18n.t('SlopeConditions.' + str);
    } else if (Object.values(SnowTypes).includes(str)) {
        return i18n.t('SnowTypes.' + str);
    } else if (Object.values(TerrainTypes).includes(str)) {
        return i18n.t('TerrainTypes.' + str);
    } else if (Object.values(CourseSetting).includes(str)) {
        return i18n.t('CourseSetting.' + str);
    } else if (Object.values(SlalomDistances).includes(str)) {
        return i18n.t('SlalomDistances.' + str);
    } else {
        return noEntryOptional(str);
    }
}

export function noEntryCheck(string) {
    return string && string !== 'NO_ENTRY' && string !== "null" && string !== "undefined";
}

export function noEntryOptional(string) {
    if (string && string !== 'NO_ENTRY' && string !== "null" && string !== "undefined") {
        return string;
    } else {
        return i18n.t('Common.NO_ENTRY');
    }
}

export function isSlalomVariant(disc) {
    return disc === Disciplines.SLALOM || disc === Disciplines.GIANT_SLALOM || disc === Disciplines.PARALLEL_GIANT_SLALOM;
}

export function emptyOrNumeric(value) {
    return !value || isNumeric(value);
}

export function isNumeric(value) {
    return /^\d+$/.test(value);
}

export function isPositiveNumeric(value) {
    return /^[1-9]\d*$/.test(value);
}

export function parseTraining(result) {
    const runs = formatRuns(result);
    const newTraining = formatTrainingDetails(result);
    newTraining['runs'] = runs;
    newTraining['id'] = result.id;
    newTraining['numberOfInterims'] = getNumberOfInterims(runs);

    return newTraining;
}

const getNumberOfInterims = (runsToSearch) => {
    let numberInterims = 0;
    if (runsToSearch) {
        runsToSearch.forEach((run) => {
            if (run) {
                run.times?.forEach((time) => {
                    if (time.sequenceIndex) {
                        numberInterims = Math.max(numberInterims, time.sequenceIndex);
                    }
                });
            }
        });
    }
    return numberInterims;
};

function formatTrainingDetails(training) {
    return {
        date: new Date(Date.parse(training.date)),
        discipline: training.skiTrainingProperties?.discipline,
        courseSetter: training.skiTrainingProperties?.courseSetter,
        slope: training.slope,
        snowType: training.skiTrainingProperties?.snowType,
        slopeCondition: training.skiTrainingProperties?.slopeCondition,
        terrain: training.skiTrainingProperties?.terrain,
        courseSetting: training.skiTrainingProperties?.courseSetting,
        gateDistance: training.skiTrainingProperties?.gateDistance,
        gateCount: training.skiTrainingProperties?.gateCount,
        turnaround: training.skiTrainingProperties?.turnaround,
        numberOfRuns: training.runs?.length,
        avgRunTime: msToTime(training.avgRunTime),
        club: training.club
    };
}

function formatRuns(training) {
    return training.runs.map((run) => {
        const formatted = {
            id: run.id,
            idx: run.idx,
            run: run.round,
            athlete: {
                fullName: run.athlete?.fullName,
                shortName: run.athlete?.shortName
            },
            team: run.athlete?.team?.name,
            notes: run.note,
            ski: run.equipment?.ski ?? '',
            binding: run.equipment?.binding ?? '',
            boots: run.equipment?.shoe ?? '',
            plate: run.equipment?.plate ?? '',
            trainingId: run.trainingId,
            skiEquipmentId: run.equipment?.id ?? null
        };

        formatted['team'] = findTeamOf(run.athlete);

        formatted['times'] = run.times?.map((time) => {
            return {
                id: time.id,
                ms: time.missed ? null : intervalStringToMilliseconds(time.timeInterval),
                sequenceIndex: time.sequenceIndex,
                missed: time.missed,
                dnf: time.dnf,
                endTime: time.endTime
            };
        });

        return formatted;
    });
}

function findTeamOf(athlete) {
    const foundTeam = athlete?.team;

    return foundTeam?.name;
}